/* bk-basis.js – kleine Grundfunktionen für alle Seiten (17.10.2026).
   Ersetzt bretterkiste.js und bretterkiste-global.js (zusammen 670 KB, überwiegend eine veraltete
   Produktliste). Übernommen wurden nur die Teile, die das Theme noch aufruft:
   Handy-Menü (bkToggleMobileNav), FAQ-Aufklapper (bkToggleFaq) und die E-Mail-Verschleierung.
   Untermenüs im Handy-Menü: bkToggleMobileSub steht in snippets/site-header.liquid. */

/* Handy-Menü (Burger) */
function bkToggleMobileNav() {
  var btn = document.getElementById('bk-hamburger');
  var nav = document.getElementById('bk-mobile-nav');
  if (!btn || !nav) return;
  var oeffnen = !nav.classList.contains('open');
  nav.classList.toggle('open', oeffnen);
  btn.classList.toggle('open', oeffnen);
  btn.setAttribute('aria-label', oeffnen ? 'Menü schließen' : 'Menü öffnen');
  btn.setAttribute('aria-expanded', oeffnen ? 'true' : 'false');
  /* Seite sperren am <html>, nicht am <body>: html hat overflow-x: clip, dadurch würde body selbst zum Scroll-Bereich
     und die angeheftete Kopfleiste (mit dem Schließen-Knopf) verschwände, wenn das Menü gescrollt geöffnet wird.
     scrollbar-gutter hält den Platz der Scrollleiste frei, damit nichts springt */
  var wurzel = document.documentElement;
  wurzel.style.overflow = oeffnen ? 'hidden' : '';
  wurzel.style.scrollbarGutter = oeffnen ? 'stable' : '';
}
/* Menü schließen bei Klick auf einen Link darin, mit Esc oder wenn das Fenster breit genug für die volle Navigation wird */
document.addEventListener('click', function (e) {
  var nav = document.getElementById('bk-mobile-nav');
  if (nav && nav.classList.contains('open') && e.target.closest('#bk-mobile-nav a')) bkToggleMobileNav();
});
document.addEventListener('keydown', function (e) {
  var nav = document.getElementById('bk-mobile-nav');
  if (e.key === 'Escape' && nav && nav.classList.contains('open')) bkToggleMobileNav();
});
window.addEventListener('resize', function () {
  var nav = document.getElementById('bk-mobile-nav');
  if (nav && nav.classList.contains('open') && window.innerWidth > 1440) bkToggleMobileNav();
});

/* FAQ: immer nur eine Antwort offen */
function bkToggleFaq(btn) {
  var item = btn.closest('.faqp-item');
  if (!item) return;
  var warOffen = item.classList.contains('open');
  document.querySelectorAll('.faqp-item.open').forEach(function (i) { i.classList.remove('open'); });
  if (!warOffen) item.classList.add('open');
  btn.setAttribute('aria-expanded', warOffen ? 'false' : 'true');
}

/* E-Mail-Verschleierung: .bk-email-obf (Zeichencodes in data-e, siehe snippets/obfuscated-email.liquid)
   wird erst im Browser zur lesbaren bzw. klickbaren Adresse – Schutz vor Adress-Sammlern. */
(function () {
  function entschluesseln(codes) {
    return codes.split(',').map(function (c) { return String.fromCharCode(parseInt(c, 10)); }).join('');
  }
  function anwenden() {
    document.querySelectorAll('.bk-email-obf:not([data-bk-done])').forEach(function (el) {
      var codes = el.getAttribute('data-e');
      if (!codes) return;
      var email = entschluesseln(codes);
      if (el.tagName === 'A' || el.classList.contains('bk-email-obf--link')) el.setAttribute('href', 'mailto:' + email);
      if (!el.textContent.trim()) el.textContent = email;
      el.setAttribute('data-bk-done', '1');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', anwenden); else anwenden();
})();
